/**
 * @generated SignedSource<<e1acd6c716077f86fe6308d8a6b76c63>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RaffleStatus = "LOSER" | "ONGOING" | "WINNER" | "%future added value";
export type RaffleUsecase = "CONSOLATION" | "EMPTY" | "PRIZE" | "%future added value";
export type playQuery$variables = {
  hubName: string;
  raffleId: string;
};
export type playQuery$data = {
  readonly hubMeta: {
    readonly hub: {
      readonly id: string;
      readonly meta: {
        readonly id: string;
        readonly name: string;
        readonly street: string;
      };
      readonly raffle: {
        readonly reservations: ReadonlyArray<{
          readonly id: string;
          readonly space: {
            readonly frame: string;
            readonly id: string;
            readonly position: number;
          };
          readonly usecase: RaffleUsecase;
        }>;
      } | null | undefined;
      readonly slug: string;
    };
    readonly id: string;
    readonly name: string;
  };
  readonly raffle: {
    readonly id: string;
    readonly raffleAttempts: ReadonlyArray<{
      readonly id: string;
      readonly reservation: {
        readonly id: string;
        readonly usecase: RaffleUsecase;
      };
    }>;
    readonly status: RaffleStatus;
  };
};
export type playQuery = {
  response: playQuery$data;
  variables: playQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "raffleId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "HubMeta",
  "kind": "LinkedField",
  "name": "meta",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "street",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usecase",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "HubRaffle",
  "kind": "LinkedField",
  "name": "raffle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RaffleReservation",
      "kind": "LinkedField",
      "name": "reservations",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        (v6/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Space",
          "kind": "LinkedField",
          "name": "space",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "position",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "frame",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "raffleId"
    }
  ],
  "concreteType": "Raffle",
  "kind": "LinkedField",
  "name": "raffle",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RaffleAttempt",
      "kind": "LinkedField",
      "name": "raffleAttempts",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RaffleReservation",
          "kind": "LinkedField",
          "name": "reservation",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v6/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "playQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": {
                "alias": null,
                "args": null,
                "concreteType": "Hub",
                "kind": "LinkedField",
                "name": "hub",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v4/*:: as any*/),
                  {
                    "kind": "RequiredField",
                    "field": (v5/*:: as any*/),
                    "action": "THROW"
                  },
                  (v7/*:: as any*/)
                ],
                "storageKey": null
              },
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "kind": "RequiredField",
        "field": (v8/*:: as any*/),
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "playQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "hub",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v8/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "c4148068f245b15afa8aa7171e286ef9",
    "id": null,
    "metadata": {},
    "name": "playQuery",
    "operationKind": "query",
    "text": "query playQuery(\n  $hubName: String!\n  $raffleId: UUID!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    hub {\n      id\n      slug\n      meta {\n        id\n        name\n        street\n      }\n      raffle {\n        reservations {\n          id\n          usecase\n          space {\n            id\n            position\n            frame\n          }\n        }\n      }\n    }\n  }\n  raffle(id: $raffleId) {\n    id\n    status\n    raffleAttempts {\n      id\n      reservation {\n        id\n        usecase\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c930f141d73a5bdb6bb43c98753a3f71";

export default node;
